// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-fair-play-penalties-list__container {
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
    background: var(--white-color);
    margin-top: 36px;
}

.tournament-fair-play-penalties-list__container .icon {
    grid-area: icon;
}

.tournament-fair-play-penalties-list__container .hubicon-add_option {
    font-size: 24px;
}

.tournament-fair-play-penalties-list__title {
    padding: 12px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid var(--new-gray-background-color);
}

.tournament-fair-play-penalties-list__title .button {
    padding: 10px 12px;
}

.tournament-fair-play-penalties-list__title .baloa-names {
    color: var(--primary-very-dark-color);
}

.tournament-fair-play-penalties-list__title .baloa-table {
    color: var(--primary-very-dark-color);
}

.tournament-fair-play-penalties-list__list {
    padding: 0 24px 16px 24px;
}

.tournament-fair-play-penalties-list__list .empty-message {
    text-align: center;
    margin: 50px 0;
}

.tournament-fair-play-penalties-list__list-item {
    padding: 14px 0 10px 0;
    border-bottom: 1px solid var(--new-gray-background-color);
}

.tournament-fair-play-penalties-list__list-item:last-child {
    border-bottom: none;
}

.tournament-fair-play-penalties-list__list-item__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.tournament-fair-play-penalties-list__list-item__header__name {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.tournament-fair-play-penalties-list__list-item__header__name .baloa-table {
    color: var(--primary-very-dark-color);
    font-weight: var(--font-medium);
}

.tournament-fair-play-penalties-list__list-item__header__name img {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    margin-right: 10px;
}


.tournament-fair-play-penalties-list__list-item__header__name .icon-ball{
    font-size: 30px;
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 3px;
    height: 36px;
    color: var(--white-color);
    margin-right: 10px;
}

.tournament-fair-play-penalties-list__list-item__header .icon-options {
    font-size: 20px;
    cursor: pointer;
}

.tournament-fair-play-penalties-list__list-item__header .icon-options.disabled {
    cursor: not-allowed;
    pointer-events: none;
    color: var(--disabled-color);
}

.tournament-fair-play-penalties-list__list-item__sanction-type.Sport {
    border: 1px solid var(--new-yellow-color);
    color: var(--new-yellow-color);
    background: rgba(255, 162, 61, 0.15);
    border-radius: 25px;
    padding: 2px 6px;
    width: fit-content;
    margin-top: 10px;
}
.tournament-fair-play-penalties-list__list-item__sanction-type.Extra_Sport {
    border: 1px solid var(--error-color);    
    color: var(--error-color);
    background: rgba(255, 81, 91, 0.15);
    border-radius: 25px;
    padding: 2px 6px;
    width: fit-content;
    margin-top: 10px;
}

.tournament-fair-play-penalties-list__list-item__sanction.baloa-table {
    color: var(--primary-very-dark-color);
    margin-top: 10px;
}

.tournament-fair-play-penalties-list__view-more.baloa-names {
    color: var(--new-green-color);
    margin-top: 10px;
    text-align: center;
    cursor: pointer;
}

.tournament-fair-play-penalties-list__list-item__skeleton-header {
    display: flex;
    align-items: center;
    gap: 10px;
    justify-content: flex-start;
    margin-bottom: 10px;
}

.tournament-fair-play-penalties-list__list-item__menu {
    position: relative;
}

.tournament-fair-play-penalties-list__header-menu-options {
    display: none;
    position: absolute;
    background: var(--white-color);
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);    
    width: 210px;
    right: 8px;
    top: 28px;
    border-radius: 8px;
    border: 1px solid var(--new-gray-background-color);
    padding: 8px;
}

.tournament-fair-play-penalties-list__header-menu-options.show_menu {
    display: block;
}

.tournament-fair-play-penalties-list__header-menu-options__option {
    margin-bottom: 4px;
    padding: 8px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
}

.tournament-fair-play-penalties-list__header-menu-options__option:hover{
    cursor: pointer;
    background-color: var(--new-background-color);
}

.tournament-fair-play-penalties-list__header-menu-options__option.baloa-names {
    color: var(--primary-very-dark-color);
}

.tournament-fair-play-penalties-list__header-menu-options__option .icon {
    font-size: 22px;
    margin-left: 4px;
}

.tournament-fair-play-penalties-list__list-types-menu {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    padding: 12px 24px 6px 24px;
}

.tournament-fair-play-penalties-list__list-type.baloa-table {
    border-radius: 25px;
    padding: 8px 12px;
    cursor: pointer;
    border: 1px solid  var(--primary-dark-color);
    color:  var(--primary-dark-color);
}

.tournament-fair-play-penalties-list__list-type.active {
    background: #EAF7F0;
    border: 1px solid  var(--new-green-color);
    color:  var(--new-green-color);
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .tournament-fair-play-penalties-list__container {
        margin: 10px;
    }

}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-fair-play-penalties-list/TournamentFairPlayPenaltiesListComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,yDAAyD;AAC7D;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,yDAAyD;AAC7D;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,qCAAqC;IACrC,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;;AAGA;IACI,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,4BAA4B;AAChC;;AAEA;IACI,yCAAyC;IACzC,8BAA8B;IAC9B,oCAAoC;IACpC,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,mCAAmC;IACnC,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,8BAA8B;IAC9B,+CAA+C;IAC/C,YAAY;IACZ,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,kDAAkD;IAClD,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,4CAA4C;IAC5C,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;IACnB,yCAAyC;IACzC,8BAA8B;AAClC;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,YAAY;IAChB;;AAEJ","sourcesContent":[".tournament-fair-play-penalties-list__container {\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    background: var(--white-color);\n    margin-top: 36px;\n}\n\n.tournament-fair-play-penalties-list__container .icon {\n    grid-area: icon;\n}\n\n.tournament-fair-play-penalties-list__container .hubicon-add_option {\n    font-size: 24px;\n}\n\n.tournament-fair-play-penalties-list__title {\n    padding: 12px 16px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-bottom: 1px solid var(--new-gray-background-color);\n}\n\n.tournament-fair-play-penalties-list__title .button {\n    padding: 10px 12px;\n}\n\n.tournament-fair-play-penalties-list__title .baloa-names {\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-fair-play-penalties-list__title .baloa-table {\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-fair-play-penalties-list__list {\n    padding: 0 24px 16px 24px;\n}\n\n.tournament-fair-play-penalties-list__list .empty-message {\n    text-align: center;\n    margin: 50px 0;\n}\n\n.tournament-fair-play-penalties-list__list-item {\n    padding: 14px 0 10px 0;\n    border-bottom: 1px solid var(--new-gray-background-color);\n}\n\n.tournament-fair-play-penalties-list__list-item:last-child {\n    border-bottom: none;\n}\n\n.tournament-fair-play-penalties-list__list-item__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.tournament-fair-play-penalties-list__list-item__header__name {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n.tournament-fair-play-penalties-list__list-item__header__name .baloa-table {\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-medium);\n}\n\n.tournament-fair-play-penalties-list__list-item__header__name img {\n    width: 35px;\n    height: 35px;\n    border-radius: 50%;\n    margin-right: 10px;\n}\n\n\n.tournament-fair-play-penalties-list__list-item__header__name .icon-ball{\n    font-size: 30px;\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 3px;\n    height: 36px;\n    color: var(--white-color);\n    margin-right: 10px;\n}\n\n.tournament-fair-play-penalties-list__list-item__header .icon-options {\n    font-size: 20px;\n    cursor: pointer;\n}\n\n.tournament-fair-play-penalties-list__list-item__header .icon-options.disabled {\n    cursor: not-allowed;\n    pointer-events: none;\n    color: var(--disabled-color);\n}\n\n.tournament-fair-play-penalties-list__list-item__sanction-type.Sport {\n    border: 1px solid var(--new-yellow-color);\n    color: var(--new-yellow-color);\n    background: rgba(255, 162, 61, 0.15);\n    border-radius: 25px;\n    padding: 2px 6px;\n    width: fit-content;\n    margin-top: 10px;\n}\n.tournament-fair-play-penalties-list__list-item__sanction-type.Extra_Sport {\n    border: 1px solid var(--error-color);    \n    color: var(--error-color);\n    background: rgba(255, 81, 91, 0.15);\n    border-radius: 25px;\n    padding: 2px 6px;\n    width: fit-content;\n    margin-top: 10px;\n}\n\n.tournament-fair-play-penalties-list__list-item__sanction.baloa-table {\n    color: var(--primary-very-dark-color);\n    margin-top: 10px;\n}\n\n.tournament-fair-play-penalties-list__view-more.baloa-names {\n    color: var(--new-green-color);\n    margin-top: 10px;\n    text-align: center;\n    cursor: pointer;\n}\n\n.tournament-fair-play-penalties-list__list-item__skeleton-header {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    justify-content: flex-start;\n    margin-bottom: 10px;\n}\n\n.tournament-fair-play-penalties-list__list-item__menu {\n    position: relative;\n}\n\n.tournament-fair-play-penalties-list__header-menu-options {\n    display: none;\n    position: absolute;\n    background: var(--white-color);\n    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);    \n    width: 210px;\n    right: 8px;\n    top: 28px;\n    border-radius: 8px;\n    border: 1px solid var(--new-gray-background-color);\n    padding: 8px;\n}\n\n.tournament-fair-play-penalties-list__header-menu-options.show_menu {\n    display: block;\n}\n\n.tournament-fair-play-penalties-list__header-menu-options__option {\n    margin-bottom: 4px;\n    padding: 8px;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    flex-wrap: nowrap;\n}\n\n.tournament-fair-play-penalties-list__header-menu-options__option:hover{\n    cursor: pointer;\n    background-color: var(--new-background-color);\n}\n\n.tournament-fair-play-penalties-list__header-menu-options__option.baloa-names {\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-fair-play-penalties-list__header-menu-options__option .icon {\n    font-size: 22px;\n    margin-left: 4px;\n}\n\n.tournament-fair-play-penalties-list__list-types-menu {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 10px;\n    padding: 12px 24px 6px 24px;\n}\n\n.tournament-fair-play-penalties-list__list-type.baloa-table {\n    border-radius: 25px;\n    padding: 8px 12px;\n    cursor: pointer;\n    border: 1px solid  var(--primary-dark-color);\n    color:  var(--primary-dark-color);\n}\n\n.tournament-fair-play-penalties-list__list-type.active {\n    background: #EAF7F0;\n    border: 1px solid  var(--new-green-color);\n    color:  var(--new-green-color);\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .tournament-fair-play-penalties-list__container {\n        margin: 10px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
